/**
 * Download / native-share helpers for the DoozyGoMagic result.
 * Both prefer the "with details" composite image (full creator-studio card)
 * and fall back to the clean image_base64.
 *
 * Every exported bitmap is passed through the shared AI-disclaimer baker so
 * the attribution ("This is an AI-generated reference image for illustrative
 * purposes only. Terms and Conditions apply.") travels with the downloaded
 * / shared file. The on-page preview already shows the disclaimer via
 * <AIImageWithDisclaimer>.
 */
import { bakeDisclaimerOnBase64 } from "./aiDisclaimer";

export async function downloadMagicImage(result) {
  if (!result) return;
  const b64 = result.image_with_details_base64 || result.image_base64;
  if (!b64) return;
  const dataUrl = await bakeDisclaimerOnBase64(b64, "image/jpeg");
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = `doozygo-magic-${result.package}-${result.occasion}.jpg`;
  link.click();
}

export async function shareMagicImage(result) {
  if (!result) return;
  const b64 = result.image_with_details_base64 || result.image_base64;
  if (!b64) return;
  const text = `Check out how my room would look with DoozyGo's ${result.package} ${result.occasion} decoration! Book yours at www.doozygo.com`;
  if (navigator.share) {
    try {
      const dataUrl = await bakeDisclaimerOnBase64(b64, "image/jpeg");
      const blob = await fetch(dataUrl).then((r) => r.blob());
      const file = new File(
        [blob],
        `doozygo-${result.package}-${result.occasion}.jpg`,
        { type: "image/jpeg" },
      );
      await navigator.share({ text, files: [file] });
      return;
    } catch (err) {
      console.debug("[Magic] Native share fallback:", err?.message);
    }
  }
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
}
